import { render } from "./SessionLogComponent.vue?vue&type=template&id=52fff28a"
import script from "./SessionLogComponent.vue?vue&type=script&lang=js"
export * from "./SessionLogComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__